import React, { useState, useRef, useEffect, useCallback } from "react";

import { Button, Overlay, ToggleButtonGroup } from "react-bootstrap";
import { MultiSelect } from "react-multi-select-component";
import { getMyPosition, getMySpecialities, getFilteredCoaches, getLanguages } from "../../../utils/api";
import MultiRangeSlider from "../../../Coach/Common/Inputs/MultiRangeSlider";
import { debounce } from "lodash";
import { toast } from "react-toastify";

const FrontFilterComponent = ({ filters, setFilters }) => {
    const [positionOptions, setPositionOptions] = useState([]);
    const [specialityOptions, setSpecialityOptions] = useState([]);
    const [languageOptions, setLanguageOptions] = useState([]);
    const expTarget = useRef(null);
    const costTarget = useRef(null);
    const [showExp, setShowExp] = useState(false);
    const [showCost, setShowCost] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data } = await getMyPosition();
                setPositionOptions(data?.data?.map(i => ({ value: i.id, label: i.title })));

                const specialityRes = await getMySpecialities();
                setSpecialityOptions(specialityRes?.data?.data?.map(i => ({ value: i.id, label: i.name })));

                const langRes = await getLanguages();
                setLanguageOptions(langRes?.data?.data?.map(i => ({ value: i.id, label: i.name })));
            } catch (error) {
                console.error("Error fetching filter data:", error);
            }
        };
        fetchData();
    }, []);

    const updateFilter = (key, value) => {
        setFilters({ ...filters, [key]: value });
    };
    const debouncedUpdateExperience = useCallback(
        debounce((min, max) => {
            updateFilter("experience", { min, max });
        }, 500), // delay: 500ms (adjust as needed)
        [filters]
    );
    
    return (
        <div className="filter_card d-flex justify-content-between" style={{ scrollbarWidth: "thin" }}>

            <ToggleButtonGroup type="radio" name="options" defaultValue={1}>

                {/* Position Filter */}
                <MultiSelect
                    options={positionOptions}
                    value={filters.positions}
                    onChange={(value) => updateFilter("positions", value)}
                    className="select-option fs-14"
                    overrideStrings={{ selectSomeItems: "Niche..." }}
                />

                <MultiSelect
                    options={specialityOptions}
                    value={filters.specialities}
                    onChange={(value) => updateFilter("specialities", value)}
                    className="select-option fs-14"
                    overrideStrings={{ selectSomeItems: "Specialties..." }}
                />

                <MultiSelect
                    options={languageOptions}
                    value={filters.languages}
                    onChange={(value) => updateFilter("languages", value)}
                    className="select-option fs-14"
                    overrideStrings={{ selectSomeItems: "Language..." }}
                />

                <div className="btn-group">
                    <div className="btn-rd_btn fs-14" ref={expTarget} onClick={() => setShowExp(!showExp)}>
                        Experience
                    </div>
                    {/* <Overlay target={expTarget.current} show={showExp} onHide={() => setShowExp(false)} rootClose placement="bottom">
                        {props => (
                            <div {...props} style={{ marginTop: "10px", padding: "2px 10px", backgroundColor: "#f4f4f4", border: "2px solid #e5e5e5", ...props.style }}>
                                <MultiRangeSlider min={0} max={100} onChange={({ min, max }) => updateFilter("experience", { min, max })} />
                            </div>
                        )}
                    </Overlay> */}
                    <Overlay
                        target={expTarget.current}
                        show={showExp}
                        onHide={() => setShowExp(false)}
                        rootClose
                        placement="bottom"
                    >
                        {props => (
                            <div
                                {...props}
                                style={{
                                    marginTop: "10px",
                                    padding: "2px 10px",
                                    backgroundColor: "#f4f4f4",
                                    border: "2px solid #e5e5e5",
                                    ...props.style
                                }}
                            >
                                <MultiRangeSlider
                                    min={0}
                                    max={100}
                                    onChange={({ min, max }) => debouncedUpdateExperience(min, max)}
                                />
                            </div>
                        )}
                    </Overlay>

                </div>

            </ToggleButtonGroup>
            
        </div>
    );
};


export default FrontFilterComponent;
